import {  TbSettings, TbTextScan2, TbUserSquareRounded,  TbBuildingCommunity, TbLockAccess } from "react-icons/tb";

export const MENU_ITEMS = (orgId) => [
  {
    icon: <TbBuildingCommunity/>,
    primaryText: "Profile Information",
    path: `/admin/organization/${orgId}`, 
  },
  {
    icon: <TbSettings />,
    primaryText: "Configurations",
    path: `/admin/organization/${orgId}/benefits`, 
  },
  {
    icon: <TbTextScan2 />,
    primaryText: "Allowance Data",
    path: `/admin/organization/${orgId}/allowance`, 
  },
  {
    icon: <TbUserSquareRounded />,
    primaryText: "Ownership Details",
    path: `/admin/organization/${orgId}/ownership`, 
  },
  {
    icon: <TbLockAccess />,
    primaryText: "Access & Permission",
    path: `/admin/organization/${orgId}/access`, 
  },
];

export const ORGANIZATION_CATEGORY = [
  {
    "id": "93",
    "name": "Private Limited Company",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "94",
    "name": "Public Limited Company",
    "createdAt": "2023-04-03T12:59:16.000Z",
    "updatedAt": "2023-04-03T12:59:16.000Z"
  },
  {
    "id": "95",
    "name": "Partnerships",
    "createdAt": "2023-04-03T12:59:25.000Z",
    "updatedAt": "2023-04-03T12:59:25.000Z"
  },
  {
    "id": "96",
    "name": "LLP Registration",
    "createdAt": "2023-04-03T12:59:35.000Z",
    "updatedAt": "2023-04-03T12:59:35.000Z"
  },
  {
    "id": "97",
    "name": "One Person Company",
    "createdAt": "2023-04-03T12:59:44.000Z",
    "updatedAt": "2023-04-03T12:59:44.000Z"
  },
  {
    "id": "98",
    "name": "Sole Proprietorship",
    "createdAt": "2023-04-03T12:59:52.000Z",
    "updatedAt": "2023-04-03T12:59:52.000Z"
  },
  {
    "id": "99",
    "name": "Section 8 Company",
    "createdAt": "2023-04-03T13:00:00.000Z",
    "updatedAt": "2023-06-05T14:18:06.000Z"
  },
]
export const INDUSTRY_TYPE = [
  {
    "id": "1111",
    "name": "Iron and Steels",
    "createdAt": "2023-04-03T12:59:06.000Z",
    "updatedAt": "2023-06-12T13:47:58.000Z"
  },
  {
    "id": "2222",
    "name": "Tea",
    "createdAt": "2023-04-03T12:59:16.000Z",
    "updatedAt": "2023-04-03T12:59:16.000Z"
  },
  {
    "id": "3333",
    "name": "Leather",
    "createdAt": "2023-04-03T12:59:25.000Z",
    "updatedAt": "2023-04-03T12:59:25.000Z"
  },
  {
    "id": "4444",
    "name": "Jute",
    "createdAt": "2023-04-03T12:59:35.000Z",
    "updatedAt": "2023-04-03T12:59:35.000Z"
  },
  {
    "id": "5555",
    "name": "FMCG",
    "createdAt": "2023-04-03T12:59:44.000Z",
    "updatedAt": "2023-04-03T12:59:44.000Z"
  },
  {
    "id": "6666",
    "name": "Metals and Minerals",
    "createdAt": "2023-04-03T12:59:52.000Z",
    "updatedAt": "2023-04-03T12:59:52.000Z"
  },
  {
    "id": "7777",
    "name": "Cement",
    "createdAt": "2023-04-03T13:00:00.000Z",
    "updatedAt": "2023-06-05T14:18:06.000Z"
  },
  {
    "id": "888",
    "name": "Textiles and Apparels",
    "createdAt": "2023-04-03T13:00:10.000Z",
    "updatedAt": "2023-06-10T14:20:12.000Z"
  },
  {
    "id": "999",
    "name": "Logistics",
    "createdAt": "2023-04-03T13:00:20.000Z",
    "updatedAt": "2023-06-15T14:30:22.000Z"
  },
  {
    "id": "100",
    "name": "Chemicals",
    "createdAt": "2023-04-03T13:00:30.000Z",
    "updatedAt": "2023-06-20T14:40:32.000Z"
  },
  {
    "id": "117",
    "name": "Rubber",
    "createdAt": "2023-04-03T13:00:40.000Z",
    "updatedAt": "2023-06-25T14:50:42.000Z"
  },
  {
    "id": "9182",
    "name": "Gems and Jewellery",
    "createdAt": "2023-04-03T13:00:50.000Z",
    "updatedAt": "2023-06-30T15:00:52.000Z"
  },
  {
    "id": "9713",
    "name": "Pharma",
    "createdAt": "2023-04-03T13:01:00.000Z",
    "updatedAt": "2023-07-05T15:10:02.000Z"
  },
  {
    "id": "4184",
    "name": "Plastics",
    "createdAt": "2023-04-03T13:01:10.000Z",
    "updatedAt": "2023-07-10T15:20:12.000Z"
  },
  {
    "id": "6715",
    "name": "Petroleum",
    "createdAt": "2023-04-03T13:01:20.000Z",
    "updatedAt": "2023-07-15T15:30:22.000Z"
  }
]